// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'
import brand from '@/config/brand'

const primary = brand.colors.primary

export default createVuetify({
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary:       primary['500'],
          'primary-darken-1': primary['700'],
          'primary-lighten-1': primary['300'],
          secondary:     primary['600'],
          accent:        primary['400'],
          surface:       '#ffffff',
          background:    '#f8fafc',
        },
      },
    },
  },
})
